import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import magnifier from '../../../img/ico_magnifier.svg'


const SearchBar = () => {
  const [value, setValue] = useState('')
  const navigate = useNavigate()
  const onSubmit: React.FormEventHandler = (event) => {
    event.preventDefault()
    navigate(`/assistenza?ricerca=${encodeURIComponent(value)}#faqs`)
  }
  return (
    <form onSubmit={onSubmit} role="search">
      <VisuallyHiddenLabel htmlFor="ricerca-faq">
        Cerca tra le domande più frequenti
      </VisuallyHiddenLabel>
      <Input
        id="ricerca-faq"
        type="search"
        name="ricerca"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Inserisci l’argomento della ricerca"
      />
    </form>
  )
}

// clip: la label resta nell'albero accessibile ma non e' visibile. Il design
// non prevede una label a schermo, e il placeholder da solo non basta (3.3.2).
const VisuallyHiddenLabel = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`

const Input = styled.input`
  ::placeholder{
    color: #252523;
  }
  background-color: #F5F5F5;
  box-shadow: none;
  margin: auto;
   max-width: 32rem;
  display: inline-block;
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  appearance: textfield;
  font-weight: 400;
  padding-left: 5.4rem;
  padding-right: 2rem;
  background-image: url(${magnifier});
  background-position: 2rem center;
  background-repeat: no-repeat;
  background-size: 2rem;

  display: block;
  width: 100%;
  height: 4.6rem;
  border-radius: 2.3rem;
  color: #222;
  font-size: 1.3rem;
  border: 1px solid #252523;
  letter-spacing: .5px;
`

export default SearchBar
